export enum PropertyTaxSummaryType { // manualy sorted, order of items will be reflected in UI
  'no_delinquencies' = 'no_delinquencies',
  'no_delinquencies_taxes_due_within_90_days' = 'no_delinquencies_taxes_due_within_90_days',
  'delinquencies' = 'delinquencies',
  'tax_search_pending' = 'tax_search_pending',
  'property_tax_search_not_requested' = 'property_tax_search_not_requested',
}

export enum PropertyTaxSummaryTypeLabels {
  'delinquencies' = 'Delinquencies',
  'no_delinquencies_taxes_due_within_90_days' = 'No delinquencies, taxes due within 90 days',
  'no_delinquencies' = 'No delinquencies',
  'tax_search_pending' = 'Tax search pending',
  'property_tax_search_not_requested' = 'Property tax search not requested',
}
